import { isNull, isNotNull } from 'utils/isNotNull'

const contains = (array, item) => isNotNull(array.find(x => x.field === item.field))

export const mergeFilters = (dynamicFilter, staticFilters) => {
  if (isNull(staticFilters)) { return dynamicFilter }

  const gridFilter = { ...dynamicFilter }
  if (isNull(gridFilter.logic)) { gridFilter.logic = 'and' }
  if (isNull(gridFilter.filters)) { gridFilter.filters = [] }

  if (Array.isArray(staticFilters)) {
    gridFilter.filters = [
      ...gridFilter.filters.filter(x => !contains(staticFilters, x)),
      ...staticFilters
    ]
  } else {
    gridFilter.filters = [
      ...gridFilter.filters.filter(x => x.field !== staticFilters.field),
      staticFilters
    ]
  }
  return gridFilter
}

export const filterOutNullFilters = (input) => {
  if (input) {
    const newFilter = {
      ...input,
      filters: input.filters ? input.filters.filter(x => isNotNull(x.value)) : []
    }
    return newFilter.filters.length === 0 ? null : newFilter
  }

  return input
}

export const mergeSorting = (dynamicSort, staticSorting) => {
  if (isNull(staticSorting)) { return dynamicSort }

  return [...staticSorting, ...dynamicSort]
}
